<template>
  <div
    v-show="Active"
    class="my-3"
    :QuestionNo="QuestionNo"
  >
    <div
      class="bg-white rounded border"
      :class="{'border-danger':MustError }"
    >
      <h6 class="text-break text-break-word m-3">
        <span
          v-show="isMust"
          class="text-break text-break-word text-danger ml-n2"
        >*</span>{{ title }}
      </h6>
      <div
        v-if="img"
        class="px-3"
      >
        <img
          :src="img"
          alt=""
          class="mw-100 h-auto rounded"
        >
      </div>
      <hr class="mx-3">
      <div class="m-3 row">
        <div
          v-for="(Item,index) in formDetailItem"
          :key="index"
          class="p-1"
          :seqNo="index"
          :class="[answersCol]"
        >
          <div
            v-if="!Item.other"
            :class="[{
              'w-100': !Item.optionImage,
              'd-flex align-items-center mb-1': Item.other===true && CheckSelect(index),
              'bg-customize':CheckSelect(index) ,
              'bg-success':CheckSelect(index) ,
              'text-white':CheckSelect(index), 'd-flex':!Item.optionImage ,
              'flex-column':CheckSelect(index) && !Item.optionImage
            },'py-1 px-2 rounded']"
          >
            <b-form-checkbox
              v-model="value"
              name="some-checkbox"
              :value="index"
              :disabled="!disabledList.includes(index) && disableListActive"
              :style="{'color': CheckSelect(index) ? themeFontColor : ''}"
            >
              <div class="text-break text-break-word">
                {{ Item.detailItemName }}
              </div>
            </b-form-checkbox>
            <div
              v-if="!!Item.optionImage"
              class="w-50 py-1"
            >
              <img
                :src="Item.optionImage"
                alt=""
                class="mw-100 h-auto rounded"
              >
            </div>
          </div>
        </div>
        <div
          v-if="formDetailItem && formDetailItem[otherIndex] && formDetailItem[otherIndex].other"
          :seqNo="otherIndex"
          class="p-1 col-12"
        >
          <div
            :class="[{
              'bg-customize':CheckSelect(otherIndex) ,
              'bg-success':CheckSelect(otherIndex) ,
              'text-white':CheckSelect(otherIndex),
              'flex-column':CheckSelect(otherIndex) && !formDetailItem[otherIndex].optionImage,
              'd-flex':!formDetailItem[otherIndex].optionImage
            },'py-1 px-2 rounded w-100']"
          >
            <b-form-checkbox
              v-model="value"
              name="some-checkbox"
              :value="otherIndex"
              :disabled="!disabledList.includes(otherIndex) && disableListActive"
              :style="{'color': CheckSelect(otherIndex) ? themeFontColor : ''}"
            >
              <div class="text-break text-break-word">
                {{ formDetailItem[otherIndex].detailItemName }}
              </div>
            </b-form-checkbox>
            <img
              v-if="!!formDetailItem[otherIndex].optionImage"
              :src="formDetailItem[otherIndex].optionImage"
              alt=""
              class="mw-100 h-auto rounded"
            >
            <b-form-textarea
              v-if="formDetailItem[otherIndex].other===true && CheckSelect(otherIndex)"
              v-model="content"
              class="my-1 col-12"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
    </div>
    <p
      v-show="ShowMustWording"
      class="text-danger font-size-md"
    >
      {{ othercheck ? mustOtherAlertWording:mustAlertWording }}
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    formDetailItem: Array,
    choiceLimit: Number,
    QuestionNo: Number,
    title: String,
    img: String,
    must: Boolean,
    mustAlertWording: String,
    mustOtherAlertWording: String,
    Active: Boolean
  },
  data() {
    return {
      value: [],
      Old_value: [],
      ShowMustWording: false,
      MustError: false,
      isMust: this.must,
      disabledList: [],
      disableListActive: false,
      content: '',
      othercheck: false
    };
  },
  methods: {
    Check() {
      const vm = this;
      const orderQuestionIndex = vm.formDetailItem.findIndex(
        (x) => x.other === true
      );
      if (vm.isMust && vm.value.length === 0) {
        this.othercheck = false;
        vm.DisplayMustError();
        return false;
      }
      if (vm.value !== -1 && vm.content === '' && vm.value.includes(orderQuestionIndex)) {
        this.othercheck = true;
        vm.DisplayMustError();
        return false;
      }
      vm.HideMustError();
      return true;
    },
    DisplayMustError() {
      this.ShowMustWording = true;
      this.MustError = true;
    },
    HideMustError() {
      this.ShowMustWording = false;
      this.MustError = false;
    },
    CheckSelect(Selected) {
      if (this.value.includes(Selected)) {
        return true;
      }

      return false;
    }
  },
  computed: {
    ...mapState('formSetting', ['themeFontColor']),
    answersCol() {
      const maxAnswersLength = this.formDetailItem.reduce((max, item) => Math.max(max, item?.detailItemName?.length ?? 0), 0);
      const haveImage = this.formDetailItem.some((item) => item.optionImage);

      if (haveImage || maxAnswersLength > 12) return 'col-12';

      if (maxAnswersLength > 6) return 'col-12 col-md-6';

      if (maxAnswersLength > 3) return 'col-6 col-md-4';

      return 'col-4 col-md-3';
    },
    otherIndex() {
      return this.formDetailItem.findIndex((item) => item.other);
    }
  },
  watch: {
    value() {
    // 處理必填顯示
      const vm = this;
      const orderQuestionIndex = vm.formDetailItem.findIndex(
        (x) => x.other === true
      );
      if (vm.isMust && vm.value.length === 0) {
        this.othercheck = false;
        vm.DisplayMustError();
      } else {
        vm.HideMustError();
      }
      // 卡選項
      if (vm.choiceLimit !== 0 && vm.choiceLimit <= this.value.length) {
        vm.disableListActive = true;
        this.value.forEach((element) => {
          vm.disabledList.push(element);
        });
      } else {
        vm.disableListActive = false;
        vm.disabledList = [];
      }
      // 處理送出值
      const ClickIndex = vm.value.filter(
        (e) => vm.Old_value.indexOf(e) === -1
      );
      if (ClickIndex[0] === orderQuestionIndex) {
        vm.content = '';
      }
      const realvalue = [];
      this.value.forEach((element) => {
        realvalue.push(element + 1);
      });
      if ((vm.value.includes(orderQuestionIndex) && vm.value.length === 1 && vm.content === '') || vm.value.length === 0) {
        this.$emit('UpdateAnswer', this.QuestionNo, realvalue, '', false);
      } else {
        this.$emit('UpdateAnswer', this.QuestionNo, realvalue, '', true);
      }
      this.Old_value = this.value;
    },
    content() {
      const vm = this;
      const realvalue = [];
      if (vm.content !== '') {
        this.HideMustError();
      }
      const orderQuestionIndex = vm.formDetailItem.findIndex(
        (x) => x.other === true
      );
      this.value.forEach((element) => {
        realvalue.push(element + 1);
      });
      if (vm.value.includes(orderQuestionIndex) && vm.content === '' && vm.value.length === 1) {
        vm.$emit('UpdateAnswer', vm.QuestionNo, realvalue, '', false);
      } else if (vm.value.includes(orderQuestionIndex) && vm.content !== '') {
        vm.$emit('UpdateAnswer', vm.QuestionNo, realvalue, vm.content, true);
      }
    }
  }

};
</script>
